
export const isUnloadingType = (transportationTypeId: number | null): boolean => {
  return transportationTypeId === 1 || transportationTypeId === 2 || transportationTypeId === 4
}

export const isLoadingType = (transportationTypeId: number | null): boolean => {
  return transportationTypeId === 3
}
